const NO_OP = (message, ...optionalParams) => {};

  const CLogger = ({ level }) => {
  const error = console.error.bind(console);

  if (level === 'error') {
    const warn = NO_OP;
    const log = NO_OP;

    return { error, warn, log };
  }

  const warn = console.warn.bind(console);

  if (level === 'warn') {
    const log = NO_OP;

    return { error, warn, log };
  }

  const log = console.log.bind(console);

  return { error, warn, log };
};
export default CLogger;

